import { createElement, ReactNode } from "react";

export function renderWithHtmlSubSup(text: any) {
    if (typeof text !== 'string') return text;
    if (text.indexOf('<sub>') === -1 && text.indexOf('<sup>') === -1) return text;
    const result: ReactNode[] = [];
    const regex = /<(sub|sup)>(.*?)<\/\1>/g;
    let lastIndex = 0;
    let match: RegExpExecArray | null;
    let keyIndex = 0;
    while ((match = regex.exec(text)) !== null) {
        const [full, tag, inner] = match;
        const start = match.index;
        if (start > lastIndex) {
            result.push(text.slice(lastIndex, start));
        }
        result.push(createElement(tag as 'sub' | 'sup', { key: `ss-${keyIndex++}` }, inner));
        lastIndex = start + full.length;
    }
    if (lastIndex < text.length) {
        result.push(text.slice(lastIndex));
    }
    return <>{result}</>;
}


